import { IState } from '../../store';
import { IRecomendedOfferSchema } from '../../types/recommendedOffer';

export const selectBookedOfferRecommendations = (state: IState): IRecomendedOfferSchema[] =>
  state.bookedOfferRecommendations;
